'use client';

import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import { BasicProductDataResponse } from '@/src/types/catalog';

interface RecentlyViewedState {
  items: BasicProductDataResponse[];
  addItem: (item: BasicProductDataResponse) => void;
  clearItems: () => void;
}

export const useRecentlyViewedStore = create<RecentlyViewedState>()(
  persist(
    (set, get) => ({
      items: [],
      addItem: (item) => {
        if (!item) return;
        const id = item.integrationId || (item as any).id;
        const isDigital =
          Boolean(item.isDigitalCard) ||
          Boolean((item as any).isDigital) ||
          (item as any).cardType === 3 ||
          (item as any).storeType === 3 ||
          (item as any).productType === 3;

        const branchId = item.branchId || (item as any).branch?.id || (item as any).branch_id;

        // Digital cards do not require branchId, standard physical products do
        if (!id) return;
        if (!isDigital && (!branchId || String(branchId) === 'undefined')) return;

        const normalizedItem: BasicProductDataResponse = {
          ...item,
          branchId: branchId ? String(branchId) : '',
          isDigitalCard: isDigital,
        };

        const currentItems = get().items;
        const filtered = currentItems.filter((existing) => {
          const existingId = existing.integrationId || (existing as any).id;
          return String(existingId) !== String(id);
        });

        set({
          items: [normalizedItem, ...filtered].slice(0, 20),
        });
      },
      clearItems: () => set({ items: [] }),
    }),
    {
      name: 'pik_recently_viewed',
      storage: createJSONStorage(() => localStorage),
      onRehydrateStorage: () => (state) => {
        if (state && Array.isArray(state.items)) {
          state.items = state.items.filter(
            (item) =>
              item &&
              (item.isDigitalCard || (item.branchId && String(item.branchId) !== 'undefined')),
          );
        }
      },
    },
  ),
);

export default useRecentlyViewedStore;
